import { createContext, ReactNode, useContext, useEffect, useState } from "react";

import { useGetDocumentConfigQuery } from "src/core/api/documents";
import { DocumentConfig } from "src/core/interfaces/Document";

type DocumentConfigContextType = {
  config: DocumentConfig | null;
  isLoading: boolean;
  error: string | null;
};

const DocumentConfigContext = createContext<DocumentConfigContextType | undefined>(undefined);

export const DocumentConfigProvider = ({ children }: { children: ReactNode }) => {
  const [config, setConfig] = useState<DocumentConfig | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { data, isLoading: isLoadingConfig, error: errorConfig } = useGetDocumentConfigQuery();

  useEffect(() => {
    if (data) {
      setConfig(data);
    }
  }, [data]);

  useEffect(() => {
    if (errorConfig) {
      setError(errorConfig instanceof Error ? errorConfig.message : "Une erreur est survenue");
    }
  }, [errorConfig]);

  useEffect(() => {
    if (isLoadingConfig) {
      setIsLoading(isLoadingConfig);
    }
  }, [isLoadingConfig]);

  return (
    <DocumentConfigContext.Provider value={{ config, isLoading, error }}>
      {children}
    </DocumentConfigContext.Provider>
  );
};

export const useDocumentConfig = () => {
  const context = useContext(DocumentConfigContext);
  if (context === undefined) {
    throw new Error("useDocumentConfig must be used within a DocumentConfigProvider");
  }
  return context;
};
